import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useBudgetStore = create(
  persist(
    (set) => ({
      budgets: [],
      lastFetchedBudgets: null,

      /** Currently selected budget object: { details, categories, isLoading, error, isBudgetSaved, sharedStatus, budgetId } */
      selectedBudget: {
        details: {},
        categories: [],
        isLoading: true,
        error: '',
        isBudgetSaved: false,
        sharedStatus: '',
        budgetId: null,
      },

      /** ID of the active budget */
      budgetId: null,

      /** Active tab within budget view: 'expense' | 'income' | 'savings' */
      activeTab: 'expense',

      /** Current period in YYYY-MM format */
      currentDate: new Date().toISOString().slice(0, 7),

      /** Route context: 'personal' | 'family' */
      route: 'personal',

      // ===== Setters =====
      setBudgets: (budgets) => set({ budgets, lastFetchedBudgets: Date.now() }),
      upsertBudget: (budget) =>
        set((state) => {
          if (!budget) return state;

          const normalized = {
            ...budget,
            id: budget.id || budget._id,
          };
          const nextBudgets = [...(state.budgets || [])];
          const targetId = String(normalized.id || "");
          const existingIndex = nextBudgets.findIndex(
            (item) => String(item?.id || item?._id || "") === targetId
          );

          if (existingIndex >= 0) {
            nextBudgets[existingIndex] = {
              ...nextBudgets[existingIndex],
              ...normalized,
            };
          } else {
            nextBudgets.unshift(normalized);
          }

          return {
            budgets: nextBudgets,
            lastFetchedBudgets: Date.now(),
          };
        }),

      setSelectedBudget: (patch) =>
        set((state) => ({
          selectedBudget: { ...state.selectedBudget, ...patch },
        })),
      clearSelectedBudget: () =>
        set({
          selectedBudget: {
            details: {},
            categories: [],
            isLoading: true,
            error: '',
            isBudgetSaved: false,
            sharedStatus: '',
            budgetId: null,
          },
        }),

      setBudgetId: (id) =>
        set((state) => ({
          budgetId: id,
          selectedBudget: { ...state.selectedBudget, budgetId: id },
        })),
      clearBudgetId: () => set({ budgetId: null }),

      setActiveTab: (tab) => set({ activeTab: tab }),
      clearActiveTab: () => set({ activeTab: 'expense' }),

      setCurrentDate: (date) => set({ currentDate: date }),
      clearCurrentDate: () => set({ currentDate: new Date().toISOString().slice(0, 7) }),

      setRoute: (route) => set({ route }),
    }),
    {
      name: 'budget-storage',
    }
  )
);

export default useBudgetStore;
